export default {
    state: {
        courses: [],
        coursesNextUrl: undefined,

        myCourses: [],
    },
    mutations: {
        ADD_COURSES(state, payload){
            state.courses.push(...payload.data);
            state.coursesNextUrl = payload.next;
        },
        SET_COURSES(state, payload){
            state.courses = payload.data;
            state.coursesNextUrl = payload.next;
        },
        UPDATE_COURSE(state, payload){
            state.courses = state.courses.map(course=>{
                if (course.id === payload.data.id){
                    course = Object.assign(course, payload.data);
                }
                return course;
            })
        },
        SET_MY_COURSES(state, payload){
            state.myCourses = payload.data;
        },
        ADD_TO_MY_COURSES(state, payload){
            state.myCourses.push(...payload.data);
        },

    },
    actions: {
        getCourses({state, commit}, payload){
            const next = state.coursesNextUrl;
            if (next || next === undefined || payload.initialLoad){
    
    
                const url = payload.initialLoad || !next ? '/courses' : next;
                let params = {...payload.data};

                return window.axios.get(url, {params}).then(response=>{
                    let data = {data: response.data.data, next: response.data.links.next};
                    if (payload.initialLoad){
                        commit('SET_COURSES', data);
                    }else{
                        commit('ADD_COURSES', data);
                    }
                });
            }
        },
        joinCourse({state, commit}, payload){
            const url = '/courses/' + payload.id + '/join';

            return new Promise((resolve, reject)=>{
                window.axios.post(url).then(response=>{
                    commit('ADD_TO_MY_COURSES', {data: [response.data.data]});
                    commit('UPDATE_COURSE', {data: response.data.data});
                    resolve(response)
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        purchaseCourse({state, commit}, payload){
            const url = '/courses/' + payload.id + '/purchase';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    commit('ADD_TO_MY_COURSES', {data: [response.data.data]});
                    commit('UPDATE_COURSE', {data: response.data.data});
                    resolve(response)
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        purchaseLecture({state, commit}, payload){
            const url = '/lectures/' + payload.id + '/purchase';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    // commit('UPDATE_COURSE', {data: response.data.data});
                    if (response.data.balance || response.data.balance === 0){
                        commit('SET_USER_BALANCE', response.data.balance);
                    }
                    resolve(response)
                }).catch(error=>{
                    reject(error);
                });
            });
        },

    }
}